import { useAuthStore } from '@/modules/auth/stores/auth.store'
import { getFirstAvailableRoute } from '@/router'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

export function isAuthenticatedGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): void {
  const authStore = useAuthStore()

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)

  const guestOnly = to.matched.some((record) => record.meta.guestOnly)

  const requiredRoles = to.meta.roles as string[] | undefined

  if (authStore.isAuthenticated) {
    if (guestOnly) {
      // Usuario autenticado accediendo a ruta de invitados, redirigir a su primera ruta
      const firstRoute = getFirstAvailableRoute(authStore.userRole)
      next(firstRoute)
      return
    }

    // Verificar si el usuario tiene acceso a la ruta por su rol
    if (requiredRoles && requiredRoles.length > 0) {
      const hasAccess = requiredRoles.some(role => authStore.hasRole(role))
      if (!hasAccess) {
        if (import.meta.env.DEV) {
          console.warn(`⚠️ Acceso denegado: se requiere rol '${requiredRoles.join(' o ')}', usuario tiene '${authStore.userRole}'`)
        }
        const firstRoute = getFirstAvailableRoute(authStore.userRole)
        next(firstRoute)
        return
      }
    }

    next()
    return
  }

  if (requiresAuth) {
    next({
      name: 'Login',
      query: { redirect: to.fullPath },
    })
    return
  }

  next()
}
